import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=b91a878e&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=b91a878e&prod&lang=scss&scoped=true"
import style1 from "./UsersList.vue?vue&type=style&index=1&id=b91a878e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91a878e",
  null
  
)

export default component.exports